import React from 'react';
import Select from 'react-select';
import './style.css';
import { useFormikContext } from 'formik';

const SelectBox = ({ rest, field, placeholder, options, isClearable }) => {
  const { setFieldValue } = useFormikContext();

  return (
    <div className='admin-react-select-box'>
      <Select
        {...field}
        {...rest}
        // menuIsOpen={true}
        // value={field.value}
        name={field.name}
        placeholder={placeholder}
        options={options}
        onChange={(value) => {
          setFieldValue(field.name, value);
        }}
        styles={{
          option: (styles, { isSelected, isDisabled }) => ({
            ...styles,
            backgroundColor: isSelected ? '#10182d' : '#1B243A',
            color: isSelected ? '#fff' : '#fff',
            cursor: isDisabled ? 'not-allowed' : 'pointer',
            marginTop: '0px',
            marginBottom: '0px',
          }),
        }}
        isClearable={isClearable ? isClearable : false}
      />
    </div>
  );
};

export default SelectBox;
